module.exports = __webpack_public_path__ + "img/tulip_half.3399710f.svg";